module.exports = __webpack_public_path__ + "static/media/header-bg-2.8b8d050b.jpg";